import { buildDroneCzmlPackage } from './marker_utils'

class DroneMarker {
  constructor ({ cesiumViewer, serialNumber }) {
    this._cesiumViewer = cesiumViewer // May be null at construction time
    this._dataSource = null
    this._czmlPackages = []
    this._entity = null

    this.serialNumber = serialNumber
    this.name = null
    this.latitude = null
    this.longitude = null
    this.elevation = null
  }

  droneId () {
    return 'drone_' + this.serialNumber
  }

  droneName () {
    if (!this.name) {
      return 'Drone: ' + this.serialNumber
    }

    return this.name
  }

  get entity () {
    return this._entity
  }

  update ({ name, elevation, position }, lastTimestamp) {
    if (name) this.name = name

    if (position && position.latitude && position.longitude) {
      this.latitude = position.latitude
      this.longitude = position.longitude
      this.elevation = elevation
    }

    if (this.latitude && this.longitude && this.elevation && lastTimestamp) {
      // Add a new CZML package for this position
      this._czmlPackages.push(buildDroneCzmlPackage({
        droneId: this.droneId(),
        droneName: this.droneName(),
        latitude: this.latitude,
        longitude: this.longitude,
        elevation: this.elevation,
        timestamp: lastTimestamp
      }))
    }

    return this._refreshEntity()
  }

  _refreshEntity () {
    // Build the data source if we don't have one yet
    if (!this._dataSource) {
      this._dataSource = new Cesium.CzmlDataSource(this.droneId())
      this._cesiumViewer.dataSources.add(this._dataSource)
    }

    // Process all CZML packages
    const packagesToProcess = this._czmlPackages.slice()
    this._czmlPackages = []
    let returnPromise = null

    packagesToProcess.forEach((czmlPackage) => {
      returnPromise = this._dataSource.process(czmlPackage)
    })

    if (returnPromise && !this._entity) {
      returnPromise = returnPromise.then(() => {
        this._entity = this._dataSource.entities.getById(this.droneId())
      })
    }

    return returnPromise || Promise.resolve()
  }
}

export const withDroneMarkers = (_controller, { cesiumViewer }) => {
  const droneMarkers = new Map()

  return {
    update: (droneData, lastTimestamp) => {
      const serialNumber = droneData.serial_number
      if (!serialNumber) return Promise.resolve()

      let droneMarker = droneMarkers.get(serialNumber)
      if (!droneMarker) {
        droneMarker = new DroneMarker({ cesiumViewer, serialNumber })
        droneMarkers.set(serialNumber, droneMarker)
      }

      return droneMarker.update(droneData, lastTimestamp)
    },
    getEntity: () => {
      // Return the first Dock Entity (for now)
      for (const droneMarker of droneMarkers.values()) {
        const entity = droneMarker.entity
        if (entity) return entity
      }
      return null
    }
  }
}
